type LegalFooterProps = {
  inverse?: boolean;
};

const LegalFooter = ({ inverse = false }: LegalFooterProps) => {
  return (
    <footer className={`legal-footer${inverse ? " legal-footer-inverse" : ""}`}>
      <a href="/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      <span aria-hidden="true">|</span>
      <a href="/eula.pdf" target="_blank" rel="noopener noreferrer">
        EULA
      </a>
    </footer>
  );
};

export default LegalFooter;
